import styled, { css } from 'styled-components';

import { flexCenter } from 'styles/mixins/index';

export const DropContainer = styled.div<{ withoutBg?: boolean }>`
  position: relative;
  height: 120px;
  border-radius: 16px;
  overflow: hidden;

  ${({ theme, withoutBg }) => css`
    border: 1px dashed ${theme.colors.grey.primary.standard};
    background: ${withoutBg ? 'none' : theme.colors.grey.tertiary.standard};
    span {
      color: ${theme.config.link.default};
    }
  `}
`;

export const ViewArea = styled.div`
  display: contents;
`;

export const Wrapper = styled.div<{
  $overImage?: boolean;
  $withActions?: boolean;
}>`
  ${flexCenter};
  flex-direction: column;
  gap: 8px;
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  padding: 24px;

  h4 {
    max-width: 90%;
  }

  svg path {
    fill: ${({ theme }) => theme.config.text.primary};
  }

  ${({ $overImage }) =>
    $overImage &&
    css`
      top: auto;
      /* Above the photo's hover shade (components/image, z-index 10), so
         taps on the strip and its buttons reach them, not the photo. */
      z-index: 11;
      padding: 6px 12px;
      background: rgba(255, 255, 255, 0.92);
      border-top: 1px solid rgba(0, 0, 0, 0.06);

      h4 {
        max-width: 100%;
        font-size: 13px;
      }
    `}

  ${({ $overImage, $withActions }) =>
    $overImage &&
    $withActions &&
    css`
      flex-direction: row;
      justify-content: space-between;
      padding: 4px 6px 4px 12px;

      h4 {
        min-width: 0;
        flex: 1;
        text-align: left;
      }
    `}
`;

export const Actions = styled.div`
  display: flex;
  flex-shrink: 0;
  gap: 6px;

  button {
    height: 28px;
    padding: 0 12px;
    border: none;
    border-radius: 8px;
    font: inherit;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    ${({ theme }) => css`
      color: ${theme.config.link.default};
      background: ${theme.colors.grey.tertiary.standard};
    `}
  }
`;
